import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

export default class HideOnScroll {
  constructor(element) {
    this.element = element;

    // tolerance: after scrolling how many pixels should scrolltrigger trigger?
    this.tolerance = element.dataset.tolerance || 100; // Verhoogd van 48 naar 100

    // breakpoint in px to trigger effect
    this.breakpoint = element.dataset.breakpoint;

    // Initialize navElement
    this.navElement = document.querySelector('.nav');

    // Debouncing variabelen
    this.isScrolling = false;
    this.scrollTimeout = null;

    this.init();
  }

  init() {
    const mm = gsap.matchMedia();

    mm.add(this.breakpoint, () => {
      ScrollTrigger.observe({
        target: window,
        type: 'scroll',
        tolerance: this.tolerance,
        onUp: () => {
          this.debouncedShow();
        },
        onDown: () => {
          this.debouncedHide();
        },
      });

      return () => {
        this.element.classList.remove('hide-on-scroll');
        this.showHeader();
      };
    });
  }

  // Debounced functies om flikkering te voorkomen
  debouncedShow() {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }

    this.scrollTimeout = setTimeout(() => {
      this.showHeader();
    }, 50); // 50ms debounce
  }

  debouncedHide() {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }

    this.scrollTimeout = setTimeout(() => {
      this.hideHeader();
    }, 50); // 50ms debounce
  }

  showHeader() {
    this.element.classList.remove('hide-on-scroll');
    if (this.navElement) {
      this.navElement.classList.remove('hide-on-scroll');
    }
    document.querySelector('.header').classList.remove('pointer-events-none');
  }

  hideHeader() {
    this.element.classList.add('hide-on-scroll');
    if (this.navElement) {
      this.navElement.classList.add('hide-on-scroll');
    }
    document.querySelector('.header').classList.add('pointer-events-none');
  }
}
